import { get, post } from "./auth";
import { admin, resultHandler } from "./admin";

// cash registers
function getBankTerminals(handler, restaurantId) {
    get("adminService/" + (typeof restaurantId === "undefined" ? localStorage.restaurantSelected : restaurantId) + "/getBankTerminals?lang=" + localStorage.language, localStorage.restaurantSelected).done(function (data) {
        if (data === null) {
            console.log("Failed to get BankTerminals!");
        } else {
            handler(data);
        }
    });
}
admin.getBankTerminals = getBankTerminals;
function getBankTerminalsStatus(handler, restaurantId) {
    get("adminService/" + (typeof restaurantId === "undefined" ? localStorage.restaurantSelected : restaurantId) + "/getBankTerminalsStatus", localStorage.restaurantSelected).done(function (data) {
        if (data === null) {
            console.log("Failed to get BankTerminals status!");
        } else {
            handler(data);
        }
    });
}
admin.getBankTerminalsStatus = getBankTerminalsStatus;
function modifyBankTerminal(bankTerminal, handler, errorHandler) {
    post("adminService/" + localStorage.restaurantSelected + "/modifyBankTerminal", bankTerminal).done(function (data) {
        resultHandler(data, handler, errorHandler);
    });
}
admin.modifyBankTerminal = modifyBankTerminal;
function addBankTerminal(bankTerminal, handler, errorHandler) {
    post("adminService/" + localStorage.restaurantSelected + "/addBankTerminal", bankTerminal).done(function (data) {
        resultHandler(data, handler, errorHandler);
    });
}
admin.addBankTerminal = addBankTerminal;
function deleteBankTerminal(id, handler, errorHandler) {
    get("adminService/" + localStorage.restaurantSelected + "/deleteBankTerminal/" + id).done(function (data) {
        resultHandler(data, handler, errorHandler);
    });
}
admin.deleteBankTerminal = deleteBankTerminal;
